import { useState } from 'react'

/**
 * @internal Implementation detail of KestrelViewerProvider.
 * Do not use directly—use the context values exposed by KestrelViewerProvider.
 *
 * Manages temperature probe loading state.
 * Event handlers for temperature probing are in KestrelInitializer.
 */
export const useTemperatureProbe = () => {
  const [temperatureProbeLoading, setTemperatureProbeLoading] = useState(false)

  return {
    temperatureProbeLoading,
    setTemperatureProbeLoading,
  }
}
